import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initSentry } from "./utils/sentry";
import { initInstallPrompt, registerServiceWorker } from "./utils/pwa";

// Error tracking, only when REACT_APP_SENTRY_DSN is set at build time
initSentry().catch(() => {});

// Installable app: keep the browser's install prompt and register the service worker
initInstallPrompt();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
